/**
 * Hook: Text-to-speech via WebSpeech API
 */
import { useState } from 'react'

export function useTTS(lang?: string) {
  const [enabled, setEnabled] = useState(false)
  const [speaking, setSpeaking] = useState(false)

  const speak = (text: string) => {
    if (!enabled || !text) { return }
    window.speechSynthesis.cancel()
    const utterance = new SpeechSynthesisUtterance(text)
    const langMap: Record<string, string> = { tr: 'tr-TR', en: 'en-US', de: 'de-DE', fr: 'fr-FR', es: 'es-ES' }
    utterance.lang = langMap[lang ?? ''] ?? 'en-US'
    utterance.onstart = () => setSpeaking(true)
    utterance.onend = () => setSpeaking(false)
    utterance.onerror = () => setSpeaking(false)
    window.speechSynthesis.speak(utterance)
  }

  const toggle = () => {
    if (speaking) { window.speechSynthesis.cancel(); setSpeaking(false) }
    setEnabled(prev => !prev)
  }

  return { enabled, speaking, speak, toggle }
}
